module.exports = __webpack_public_path__ + "static/media/bluebird.17ebc3c5.webp";